import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useStatusCid = () => {
  const [statusCid, setStatusCid] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchStatusCid = async () => {
      try {
        const response = await httpClient.get(`/api/medsuscid/statuscid`);

        const options = response.data.map(
          (statusCid: { value: number; label: string }) => ({
            value: statusCid.value.toString(),
            label: statusCid.label,
          }),
        );
        setStatusCid(options);
      } catch (error) {
        console.error('Erro ao buscar Status Cid', error);
      }
    };

    fetchStatusCid();
  }, []);

  return statusCid;
};
